<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NZQu98/tc-custom/9781459234598.jpg?1740800646709" alt="This image is the cover for the book Wyoming Wildcat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wyoming Wildcat
      </h1>
      <p class="bookDescription body article font2">
        <b>Ryan Tolliver Was On The Trail Of A Woman</b><br/><br/>The Wyoming rancher was only looking for the promised reward when he set off to track down the mysterious Molly Ivins, missing some eighteen years. But after a nasty fall robbed him of his memory, things got a lot more complicated.<br/><br/>Tragically orphaned at seven, Molly Ivins fell into the caring hands of a Cheyenne medicine man and came to be known as Moon Hawk. Yet when a handsome white man with amnesia burst into her life, she had to decide between newfound love and loyalty to her tribe.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Lane
      </h2>
      
      <p class="authorDescription body article">Elizabeth Lane has lived and travelled in many parts of the world, including Europe, Latin America and the Far East, but her heart remains in the American West, where she was born and raised. Her idea of heaven is hiking a mountain trail on a clear autumn day. She also enjoys music, animals and dancing. You can learn more about Elizabeth by visiting her website at &amp;lt;a href="http://www.elizabethlaneauthor.com"&amp;gt;www.elizabethlaneauthor.com&amp;lt;/a&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f74ff28